<template>
  <div>
    <b-form class="admin-form" @submit.stop.prevent="submitForm">
      <b-form-group horizontal label="Name">
        <b-form-input type="text" v-model="name"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Has Tags">
        <v-select multiple type="" v-model="hasTags" :options="tagsCollection"/>
      </b-form-group>
      <b-button type="submit" variant="primary">Submit</b-button>
      <b-button type="reset" variant="warning">Close</b-button>
      <b-button type="delete" variant="danger" v-if="subfolderForm.hasOwnProperty('id')" @click="deleteSubfolder()">Delete</b-button>
    </b-form>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'SubfolderForm',
  props: ['mailbox_id', 'subfolderId'],
  components: {
  },
  data () {
    return {
      team: {
        users: []
      }
    }
  },
  created () {
    this.getOrCreate()
  },
  computed: {
    ...mapGetters(['currentUser', 'subfolderForm', 'tagsCollection']),
    name: {
      get () {
        return this.subfolderForm.name
      },
      set (value) {
        this.updateSubfolerForm({name: value})
      }
    },
    hasTags: {
      get () {
        return this.subfolderForm.has_tags
      },
      set (value) {
        this.updateSubfolerForm({has_tags: value})
      }
    }
  },
  methods: {
    ...mapMutations(['updateSubfolerForm', 'setDefaultSubfolderForm']),
    ...mapActions(['saveSubfolder', 'getSubfolder']),
    submitForm () {
      this.saveSubfolder().then(
        response => {
          this.submitSuccessful()
        }, error => {
          console.log(error)
        }
      )
    },
    submitSuccessful (response) {
      this.setDefaultSubfolderForm()
      this.updateSubfolerForm({mailbox_id: this.mailbox_id})
      this.$root.$emit('SUBFOLDER_SUBMIT_SUCCESSFUL')
    },
    getOrCreate () {
      if (this.subfolderId) {
        this.getSubfolder([this.subfolderId, this.mailbox_id])
      } else {
        this.setDefaultSubfolderForm()
        this.updateSubfolerForm({mailbox_id: this.mailbox_id})
      }
    }
  },
  watch: {
    subfolderId: function () {
      this.getSubfolder([this.subfolderId, this.mailbox_id])
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/subfolders/Form.vue